import { createFetchingEntity } from '../../utils/effector/creatFetchingEntity';
import { IUser } from '../../http/models/models';
import UserService from '../../http/services/UserService';

export const $user = createFetchingEntity<IUser>({
	requestHandler: async () => (await UserService.getMe()).data,
	doneDataHandler: (state, payload) => payload,
	useCache: true,
});
